import './index.css'


// WEBPACK FOOTER //
// ./ecology9/base/wea-hrm-list/style/index.js